export const ALIGN_ACTION_LEFT_LABEL_TEXT = 'Align left';
export const ALIGN_ACTION_H_CENTER_LABEL_TEXT = 'Align center (horizontal)';
export const ALIGN_ACTION_RIGHT_LABEL_TEXT = 'Align right';
export const ALIGN_ACTION_TOP_LABEL_TEXT = 'Align top';
export const ALIGN_ACTION_V_CENTER_LABEL_TEXT = 'Align center (vertical)';
export const ALIGN_ACTION_BOTTOM_LABEL_TEXT = 'Align bottom';
